/**
 * @file
 * @copyright  2017 Subscribe-HR
 */

import ConditionAbstract from './ConditionAbstract';

/**
 * Subscribe-HR entity condition
 */
export default class Condition extends ConditionAbstract {

  /**
   * Entity grid decorator decorator
   * @param {string} type - AND or OR
   * @param {string} entityName
   * @param {string} fieldName
   * @param {string} operator
   * @param {string} value
   * @param {array} list of conditions
   */
  constructor(type, entityName, fieldName, operator, value) {
    super(type);
    this.entityName = entityName;
    this.fieldName = fieldName;
    this.operator = operator;
    this.value = value;
  }

  /**
   * Returns entity name
   * @return {string}
   */
  getEntityName = () => {
    return this.entityName;
  }

  /**
   * Returns field name
   * @return {string}
   */
  getFieldName = () => {
    return this.fieldName;
  }

  /**
   * Returns operator
   * @return {string}
   */
  getOperator = () => {
    return this.operator;
  }

  /**
   * Returns value
   * @return {string}
   */
  getValue = () => {
    return this.value;
  }

  /**
   * Returns object representation of condition
   * @return {object}
   */
  getDefinition = () => {
    return {
      Type: this.getType(),
      EntityName: this.entityName,
      FieldName: this.fieldName,
      Operator: this.operator,
      Value: this.value
    };
  }

  /**
   * @private
   * Translates SSQL to filter operator
   * @param {Entity} entity
   * @return {string}
   */
  getFilterOperator = (operator) => {
    switch (operator) {
      case '=':
        return 'equals';
      case '<>':
        return 'not-equals';
      case '>':
        return 'after';
      case '<':
        return 'before';
      case '>=':
        return 'after-or-same-as';
      case '<=':
        return 'before-or-same-as';
      case 'LIKE':
        return 'contains';
      case 'NOT LIKE':
        return 'not-contains';
      default:
        return 'equals';
    }
  };
}



// WEBPACK FOOTER //
// ./src/client/common/js-subscribe-sdk/lib/Entities/Condition.js